import { render, staticRenderFns } from "./TemplateEditPage.vue?vue&type=template&id=20dd8a66&"
import script from "./TemplateEditPage.js?vue&type=script&lang=js&"
export * from "./TemplateEditPage.js?vue&type=script&lang=js&"
import style0 from "./TemplateEditPage.vue?vue&type=style&index=0&id=20dd8a66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports